import http from "@/utils/http";
import { networkData } from "@/utils/data";
import { MessageBox } from "element-ui";
import util from "@/utils/util";
import { markingData } from '@/v2/utils/fixData'
// 网络阅卷
// 查询网络阅卷任务
export const queryWuhenList = (params) => http.post('/marking-main/exam/exam/get_network', params).then(res => {
	let resp = { success: false, body: { totalSize: 0, totalPage: 0, pageSize: params.pageSize, currentPage: params.currentPage, items: [] } };
	if (res.code === 200 && res.result) {
		const items = []
		for (let itemF of res.result) {
			let exam = { isExamGrading: false }
			if (itemF.base) {
				exam.examName = itemF.base.examName
				try {
					if (itemF.base.isAdd) {
						exam.examName += "（附加卷）";
					}
					if (itemF.base.isTwo) {
						exam.examName += "（二卷）";
					}
				} catch (err) { }

				exam.userId = itemF.base.userId;
				exam.examType = itemF.base.type;
				exam.examCode = itemF.base.examCode
				exam.importType = itemF.base.importType
				exam.id = itemF.base.id
			}

			if (itemF.exam) {
				exam.examId = itemF.exam.examId
				exam.schoolId = itemF.exam.schoolId
				exam.isExamGrading = itemF.exam.isGrading
			}

			exam.subjectName = itemF.subjectName;
			exam.gradeName = itemF.grade ? itemF.grade.gradeName : "--"
			exam.isMore = itemF.isMore
			exam.isSetting = itemF.isSetting
			exam.isGrading = itemF.isGrading
			exam.time = itemF.time
			exam.teacherName = itemF.teacherName
			exam.isNew = itemF.isNew
			exam.isRegion = false
			exam.teamLeaderIds = itemF.teamLeaderIds

			let className = "";

			if (itemF.class) {
				itemF.class.sort(util.compare("className"));
				for (let item of itemF.class) {
					className += item.className + "班、";
				}
				exam.classInfo = className.substring(
					0,
					className.lastIndexOf("、")
				);
			}

			items.push(exam)
		}
		resp.success = true
		resp.body.items.push(...items);
		resp.body.totalSize = parseInt(res.total);
	}
	return resp
})
// 获取区域批阅设置列表
export const queryRegionReviewSettingList = (params) => http.post('/marking-exam-grading/exam-list/school-assign-region-teacher/school/can-access', params).then(resp => {
	if (resp.success && resp.body && resp.body.items) {
		resp.body.items.forEach(element => {
			element.examType = element.type
			element.isMore = 2
			element.isSetting = 1
			element.id = element.examId
			element.isNew = 0
			element.isRegion = true
			element.teacherName = element.userName
			element.teamLeaderIds = []
		});
	}
	return resp
})
export const queryProgressList = (params) => http.get('/marking-exam-grading/monitor/schedule', params) // 查询批阅进度
export const allocationCopy = (params) => http.post('/marking-exam-grading/grading-task/copy', params) // 设置批阅任务
export const updateWuhenSet = (params) => {
	markingData.trySetParams(params)
	return http.post('/marking-exam-grading/grading-task/school/modify', params)
} // 设置批阅任务
export const deleteWuhenSet = (params) => http.post('/marking-exam-grading/grading-task/delete', params) // 删除批阅设置
export const startWuhen = (params) => http.post('/marking-exam-grading/grading-status/start/main', params) // 开始批阅
export const pauseWuhen = (params) => http.post('/marking-exam-grading/grading-status/pause/main', params) // 暂停批阅
export const endWuhen = (params) => {
	return http.get('/marking-exam-grading/grading-status/check-finish', params).then(resp => {
		if (resp.result) {
			const { message, detail } = networkData.getCheckTip(resp.result)
			MessageBox.confirm(detail, '结束批阅异常', { type: 'error', dangerouslyUseHTMLString: true })
				.then(() => { }).catch(() => { })
			return { message, code: 201 }
		} else {
			return http.put('/marking-exam-grading/grading-status/finish', params, 'form')
		}
	})
} // 结束批阅并生成报告
export const getWuHenRole = (params) => http.get('/marking-exam-grading/exam/grad/grading/role', params).then(resp => {
	if (resp.body) {
		resp.tabs = networkData.getRoleMenus(resp.body)
	}
	return resp
})
export const checkAnswer = (params) => http.get('/marking-exam-grading/grading-task/check-stand-and-doubt', params) // 检查考试是否确认标准答案
export const checkExam = (params) => http.get(`/marking-exam-grading/monitor/grading-detail-by-random`, params, 'from') // 抽查试卷
// 查询抽查老师
export const queryCheckTeacher = (params) => http.get(`marking-exam-grading/grading-teacher/all`, params, "form").then(res => {
	if (res.success && res.body.length > 0) {
		for (let index = 0; index < res.body.length; index++) {
			const element = res.body[index];
			element.nickName = element.nickName ? element.nickName : element.id.substring(element.id.length - 6) + '(已删除)'
		}
	}
	return res
})
export const setTeamLeader = (params) => http.post('/marking-exam-grading/grading-task/set-team-leader', params) // 设置阅卷组长

export const getExamQuestions = params => http.get(`/marking-exam-grading/grading-teacher/stands`, params, "form"); // 获取考试题目
export const getreadQuality = params => http.get("/marking-main/exam/grad/get_marking_quality", params); // 获取阅卷质量
export const getScoreSpread = params =>
	http.get("/marking-exam-grading/monitor/score-distribution", params).then(resp => {
		return networkData.getScoreSpread(resp)
	}) // 获取阅卷分数分布
export const getTeacherGuide = params =>
	http.post("/marking-main/exam/grad/get_teacher_guide", params, "form"); //查询老师是否看过引导
export const setTeacherGuide = params =>
	http.post("/marking-main/exam/grad/set_teacher_guide", params); //更新老师操作引导
export const pauseExamGrading = params =>
	http.post("/marking-exam-grading/grading-status/pause/group", params); //暂停网络阅卷
export const continueExamGrading = params =>
	http.post('/marking-exam-grading/grading-status/start/group', params) // 继续网络阅卷

export const getMarkingTeachAndQuestionNum = params =>
	http.post("/marking-main/exam/grad/get_all_tea_question", params, "form"); // 查询抽样复评监测的老师和题号
export const getMarkingReviewSupervision = params =>
	http.post("/marking-exam-grading/monitor/review-supervision", params); // 查询抽样复评批阅监控
export const getMarkingTeachQuestionNum = params =>
	http.post("/marking-main/exam/grad/get_marking_question", params, "form"); // 查询老师批阅过的题号
export const clearTeacherScore = params =>
	http.post('/marking-exam-grading/clear-score/group/by-teacher', params); // 清空教师分值
export const clearAllTask = params =>
	http.post('/marking-exam-grading/clear-score/all', params); // 清空所有任务
export const clearGroupTask = params =>
	http.post("/marking-exam-grading/clear-score/group", params); // 清空题组任务
export const checkExportScoreDistribution = params =>
	http.get("/marking-main/exam/grad/check_export_score_distribution", params); // 导出评分分布
export const getQuestionGroupNum = params => http.post("/marking-exam-grading/grading-task/school/task-info", params).then(resp => {
	return markingData.fixQuestionGroupNum(resp)
}); // 获取题组分配数
export const forceGenerate = params =>
	http.post("/marking-main/exam/grad/detail/force_generate", params); // 再次分配
export const presetScore = params =>
	http.post("/marking-main/exam/grad/update/preset_score", params); // 新增老师预设分数


export const listSubjectStand = (params) => http.get(`/marking-exam-manager/stand/${params.examId}/subjective`) // 获取主观题标准答案
export const getStudentMosaicPaper = (params) => http.put(`/marking-exam-manager/student-position/school/mosaic/url/${params.examId}/${params.resultId}?url=${params.url}`) // 获取学生试卷(打码)

// 获取指定考试状态
export const getExamStatusByExamIds = params => http.get("/marking-exam-manager/exam-list/status/simple", params)
